import React, { useEffect, useState } from "react";
import paymentStyle from "./payment.module.css";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export default function PaymentsAndBillings() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setError("No authentication token found. Please log in again.");
          setLoading(false);
          return;
        }

        const response = await fetch(`https://mgmt-util2.${backend_api_base_url}/all_payments`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const allPayments = data?.data || [];

        // ✅ Merge order + payment entries by razorpay_order_id
        const merged = Object.values(
          allPayments.reduce((acc, p) => {
            const orderId = p.razorpay_order_id;
            if (!orderId) return acc;

            if (!acc[orderId]) {
              acc[orderId] = { ...p };
            } else {
              acc[orderId] = {
                ...acc[orderId],
                ...p,
                verified_on: p.verified_on || acc[orderId].verified_on,
                razorpay_payment_id: p.razorpay_payment_id || acc[orderId].razorpay_payment_id,
                amount: p.amount || acc[orderId].amount,
                currency: p.currency || acc[orderId].currency,
              };
            }
            return acc;
          }, {})
        );

        // Sort latest first
        merged.sort(
          (a, b) =>
            new Date(b.created_on || b.verified_on) -
            new Date(a.created_on || a.verified_on)
        );

        setPayments(merged);
      } catch (err) {
        setError(err.message || "Failed to fetch payments");
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  if (loading) return <div className={paymentStyle.loading}>Loading payments...</div>;
  if (error) return <div className={paymentStyle.error}>Error: {error}</div>;

  return (
    <div className={paymentStyle.container}>
      <h2 className={paymentStyle.heading}>Payments & Billings</h2>
      {payments.length === 0 ? (
        <p>No payments found.</p>
      ) : (
        <div className={paymentStyle.tableWrapper}>
          <table className={paymentStyle.table}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount (INR)</th>
                <th>Plan Code</th>
                <th>Order ID</th>
                <th>Payment ID</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p, index) => {
                const isPaid = !!p.verified_on || !!p.razorpay_payment_id;
                const date = p.verified_on || p.created_on;
                return (
                  <tr key={p.payment_id || index}>
                    <td>{new Date(date).toLocaleString()}</td>
                    <td>{p.amount ? `${p.amount} ${p.currency || ""}` : "—"}</td>
                    <td>{p.planCode || "—"}</td>
                    <td className={paymentStyle.mono}>{p.razorpay_order_id || "—"}</td>
                    <td className={paymentStyle.mono}>{p.razorpay_payment_id || p.payment_id || "—"}</td>
                    <td>
                      <span
                        className={`${paymentStyle.statusBadge} ${isPaid ? paymentStyle.paid : paymentStyle.pending
                          }`}
                      >
                        {isPaid ? "Paid" : "Pending"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
